import { ofetch } from 'ofetch';
import type { FetchOptions } from 'ofetch';

const isCypressSession = (): boolean => {
    const cypressCookie = useCookie('IS_CYPRESS').value;
    return Boolean(cypressCookie);
};

const getCsrfTokenFromCookie = (): string | null => {
    const token = useCookie('XSRF-TOKEN').value;
    return token ? decodeURIComponent(token) : null;
};

const buildCypressHeaders = (
    existingHeaders: HeadersInit = {},
): HeadersInit => {
    const headers: Record<string, string> = {
        ...existingHeaders,
        'x-environment': 'cypress',
    };

    const csrfToken = getCsrfTokenFromCookie();
    if (csrfToken) {
        headers['X-XSRF-TOKEN'] = csrfToken;
    }

    return headers;
};

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig();
    const isCypressEnv = ['local', 'cypress'].includes(config.public.appEnv);

    if (isCypressEnv && isCypressSession()) {
        const customFetch = ofetch.create({
            credentials: 'include',
            onRequest({ options }: { options: FetchOptions }) {
                options.credentials = 'include';
                options.headers = buildCypressHeaders(options.headers);
            },
            onRequestError({ error }) {
                console.error('[Cypress Fetch Error]', error);
            },
        });

        // Override both global and Nuxt app $fetch instances
        globalThis.$fetch = customFetch;
        nuxtApp.$fetch = customFetch;
    }
});
